var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoTopLeftCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 399.361,
    viewBox: "0 0 400 399.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-element-2",
    d: "M202.631,399.361v-58.9l-.015-134.691L400,205.594V0H336.452A336.452,336.452,0,0,0,.036,341.234v58.127Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTopLeftCorner);
export default __webpack_public_path__ + "static/media/logo-top-left-corner.f0abc37444e704cb27e2c70fb1b03f12.svg";
export { ForwardRef as ReactComponent };